// @flow

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import StyleClasses from '../../styles/StyleClasses';
import { jsonGetRequest } from '../../store/requests';

type PropsType = {
    sessionId: string,
};

type StateType = {
    bill: ?Object,
    loading: boolean,
};

class SessionBillLink extends Component<PropsType, StateType> {
    constructor(props: PropsType) {
        super(props);
        this.state = {
            bill: null,
            loading: true,
        };
    }

    componentDidMount() {
        const query = JSON.stringify({
            location_session_id: { mode: 'eq', value: this.props.sessionId },
        });
        jsonGetRequest(`bills?query=${encodeURIComponent(query)}`)
            .then((bills) => {
                this.setState({ bill: bills && bills.length > 0 ? bills[0] : null, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    render() {
        if (this.state.loading) {
            return (
                <div className={StyleClasses.spacedElement}>
                    <h4>Bill</h4>
                    <p>Loading...</p>
                </div>
            );
        }

        const bill = this.state.bill;
        if (!bill) {
            return (
                <div className={StyleClasses.spacedElement}>
                    <h4>Bill</h4>
                    <p>No bill associated with this session.</p>
                </div>
            );
        }

        return (
            <div className={StyleClasses.spacedElement}>
                <h4>Bill</h4>
                <Link to={`/bill-info/${bill.id}`}>
                    <Badge color="info" style={{ fontSize: '0.9rem', cursor: 'pointer' }}>
                        {bill.id}
                    </Badge>
                </Link>
            </div>
        );
    }
}

export default SessionBillLink;
